import { useMemo } from "react"
import { FlexGrid, FlexGridItem, useStyletron } from "@mezo-org/mezo-clay"

import { selectActiveDeposits, useDappSelector } from "#/redux-state"
import { IS_MEZO_MAINNET } from "#/shared/constants"

import HomepageMainSectionAssetsDeposits from "./HomepageMainSectionAssetsDeposits"
import HomepageMainSectionAssetsMats from "./HomepageMainSectionAssetsMats"
import HomepageMainSectionAssetsMusd from "./HomepageMainSectionAssetsMusd"

export default function HomepageMainSectionAssets() {
  const activeDeposits = useDappSelector(selectActiveDeposits)
  const [, theme] = useStyletron()

  const hideDeposits = useMemo(
    () => activeDeposits.length === 0 && IS_MEZO_MAINNET,
    [activeDeposits.length],
  )

  const columnsCount = useMemo(() => {
    if (hideDeposits && IS_MEZO_MAINNET) return 1

    if (hideDeposits || IS_MEZO_MAINNET) return 2

    return 3
  }, [hideDeposits])

  return (
    <FlexGrid
      flexGridColumnCount={[1, 1, 1, columnsCount]}
      flexGridColumnGap={theme.sizing.scale900}
      flexGridRowGap={theme.sizing.scale600}
      marginBottom={theme.sizing.scale1000}
    >
      {!hideDeposits && (
        <FlexGridItem>
          <HomepageMainSectionAssetsDeposits />
        </FlexGridItem>
      )}
      {!IS_MEZO_MAINNET && (
        <FlexGridItem>
          <HomepageMainSectionAssetsMats />
        </FlexGridItem>
      )}
      <FlexGridItem>
        <HomepageMainSectionAssetsMusd />
      </FlexGridItem>
    </FlexGrid>
  )
}
